import { useEffect } from 'react';

const useMetronome = (func, delay = 1000) => {
    useEffect(() => func(), []);

    useEffect(() => {
        const intervalId = setInterval(func, delay);
        return () => clearInterval(intervalId);
    }, [func, delay]);
}

export default useMetronome;
